export const countryConfigSI = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'za-kolesa-in-skuterje',
    carCollection: 'za-voznike-avtomobilov'
  }
};
